export function timeout<T>(t: number, val?: T): Promise<T> {
  return new Promise(resolve => setTimeout(resolve, t, val));
}
